var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","small":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"ma-1 view-button",class:[
        _vm.isActive ? 'btn-primary white--text' : '',
        _vm.isBig ? 'big' : 'middle',
        _vm.classes
      ],attrs:{"id":'viewButton' + _vm.view.id},on:{"click":_vm.onClick}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(_vm._s(_vm.view.icon || "mdi-plus-circle-outline"))])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.view.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }